import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useState } from "react";

interface ImagePreviewDialogProps {
  src: string;
  alt: string;
  children: React.ReactNode;
}

const ImagePreviewDialog = ({ src, alt, children }: ImagePreviewDialogProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <div className="cursor-pointer">
          {children}
        </div>
      </DialogTrigger>
      <DialogContent className="max-w-4xl w-full max-h-[90vh] p-4">
        <DialogTitle className="sr-only">{alt || 'Image preview'}</DialogTitle>
        <div className="flex items-center justify-center">
          <img 
            src={src} 
            alt={alt} 
            className="max-w-full max-h-[80vh] object-contain rounded-lg"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;